import orderViewInstance from './instance'

const getOrder = (orderId) => {
	return orderViewInstance.get('/orders/' + orderId)
}

export default getOrder
